var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M261.7 130.3C260.1 128.8 258.1 128 256 128S251.9 128.8 250.3 130.3c-3.125 3.125-3.125 8.188 0 11.31L356.7 248H136C131.6 248 128 251.6 128 256s3.594 8 8 8h220.7l-106.3 106.3c-3.125 3.125-3.125 8.188 0 11.31s8.188 3.125 11.31 0l120-120c3.125-3.125 3.125-8.188 0-11.31L261.7 130.3zM256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 496c-132.3 0-240-107.7-240-240S123.7 16 256 16s240 107.7 240 240S388.3 496 256 496z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleArrowRight);
export default __webpack_public_path__ + "static/media/circle-arrow-right.1b4dbdcf4577168600ec61e1b3d60d43.svg";
export { ForwardRef as ReactComponent };